import { useMutation } from '@tanstack/react-query';

import { createDiscountVoucher } from '~/services/AgentHub/AgentService';

import { CreateDiscountVoucherParams } from '~/types/services/agentHub';

export function useCreateDiscountVoucher() {
  return useMutation({
    mutationFn: async (params: CreateDiscountVoucherParams) => {
      return await createDiscountVoucher(params);
    },
  });
}
